// src/data/demoData.js
import { toISODate, addDaysToDate } from "../utils/calendarUtils";

export const getRealisticDemoAppointments = () => {
  const today = toISODate(new Date());
  const dayMinus3 = addDaysToDate(today, -3);
  const dayMinus2 = addDaysToDate(today, -2);
  const dayMinus1 = addDaysToDate(today, -1);
  const dayPlus1 = addDaysToDate(today, 1);
  const dayPlus2 = addDaysToDate(today, 2);
  const dayPlus3 = addDaysToDate(today, 3);
  const dayPlus4 = addDaysToDate(today, 4);

  return [
    // Today's appointments
    {
      id: "apt-101",
      referenceCode: "MED-9021",
      clientName: "Eleanor Vance",
      email: "eleanor.vance@example.com",
      phone: "+1 (555) 234-5678",
      specialistId: "spec-1",
      specialistName: "Dr. Evelyn Reed",
      serviceId: "srv-1",
      serviceName: "General Health Consultation",
      date: today,
      time: "09:00",
      duration: 30,
      price: 65,
      status: "completed",
      priority: "Routine",
      room: "Suite 101 - Building A",
      notes: "Annual physical checkup. Patient reports mild seasonal allergy symptoms. Prescribed antihistamine.",
      createdAt: new Date(Date.now() - 3600000 * 24 * 2).toISOString()
    },
    {
      id: "apt-102",
      referenceCode: "MED-9022",
      clientName: "David Sterling",
      email: "david.sterling@example.com",
      phone: "+1 (555) 876-5432",
      specialistId: "spec-3",
      specialistName: "Dr. Sophia Patel",
      serviceId: "srv-3",
      serviceName: "Cardiology Review & ECG",
      date: today,
      time: "10:30",
      duration: 60,
      price: 150,
      status: "in-progress",
      priority: "Urgent",
      room: "Cardiac Center 4A",
      notes: "Routine post-stent evaluation. Resting ECG recorded. Blood pressure 125/82 mmHg.",
      createdAt: new Date(Date.now() - 3600000 * 24 * 3).toISOString()
    },
    {
      id: "apt-103",
      referenceCode: "MED-9023",
      clientName: "Chloe Davenport",
      email: "chloe.d@example.com",
      phone: "+1 (555) 345-6712",
      specialistId: "spec-2",
      specialistName: "Dr. Marcus Vance",
      serviceId: "srv-2",
      serviceName: "Dental Cleaning & Examination",
      date: today,
      time: "13:00",
      duration: 45,
      price: 95,
      status: "confirmed",
      priority: "Routine",
      room: "Dental Clinic 2B",
      notes: "Routine 6-month prophylaxis. Scaling and polishing requested.",
      createdAt: new Date(Date.now() - 3600000 * 18).toISOString()
    },
    {
      id: "apt-104",
      referenceCode: "MED-9024",
      clientName: "Julian Thorne",
      email: "j.thorne@example.com",
      phone: "+1 (555) 432-1098",
      specialistId: "spec-4",
      specialistName: "Dr. Alexander Kim",
      serviceId: "srv-4",
      serviceName: "Dermatology Skin Screening",
      date: today,
      time: "15:00",
      duration: 30,
      price: 110,
      status: "pending",
      priority: "Follow-up",
      room: "Derma Lab 3C",
      notes: "Review mole changes on left shoulder. Pre-biopsy photographic mapping.",
      createdAt: new Date(Date.now() - 3600000 * 5).toISOString()
    },
    {
      id: "apt-105",
      referenceCode: "MED-9025",
      clientName: "Liam Montgomery",
      email: "liam.montgomery@example.com",
      phone: "+1 (555) 987-1234",
      specialistId: "spec-5",
      specialistName: "Dr. Maya Lindqvist",
      serviceId: "srv-6",
      serviceName: "Orthopedic Physical Therapy",
      date: today,
      time: "16:00",
      duration: 50,
      price: 120,
      status: "confirmed",
      priority: "Routine",
      room: "Rehab Gym 1F",
      notes: "Runner's knee rehabilitation phase 2. Hamstring eccentrics and patellar taping.",
      createdAt: new Date(Date.now() - 3600000 * 12).toISOString()
    },

    // Tomorrow's appointments
    {
      id: "apt-106",
      referenceCode: "MED-9026",
      clientName: "Amara O'Connor",
      email: "amara.oc@example.com",
      phone: "+1 (555) 654-3210",
      specialistId: "spec-1",
      specialistName: "Dr. Evelyn Reed",
      serviceId: "srv-5",
      serviceName: "Pediatric Wellness Check",
      date: dayPlus1,
      time: "09:30",
      duration: 40,
      price: 80,
      status: "confirmed",
      priority: "Routine",
      room: "Suite 101 - Building A",
      notes: "18-month developmental review and scheduled booster vaccination.",
      createdAt: new Date(Date.now() - 3600000 * 20).toISOString()
    },
    {
      id: "apt-107",
      referenceCode: "MED-9027",
      clientName: "Nathaniel Brooks",
      email: "nbrooks@example.com",
      phone: "+1 (555) 789-0123",
      specialistId: "spec-2",
      specialistName: "Dr. Marcus Vance",
      serviceId: "srv-2",
      serviceName: "Dental Cleaning & Examination",
      date: dayPlus1,
      time: "11:00",
      duration: 45,
      price: 95,
      status: "pending",
      priority: "Routine",
      room: "Dental Clinic 2B",
      notes: "First time visit. Reports slight sensitivity to cold beverages on lower right molar.",
      createdAt: new Date(Date.now() - 3600000 * 8).toISOString()
    },
    {
      id: "apt-108",
      referenceCode: "MED-9028",
      clientName: "Seraphina Lin",
      email: "s.lin@example.com",
      phone: "+1 (555) 890-1234",
      specialistId: "spec-3",
      specialistName: "Dr. Sophia Patel",
      serviceId: "srv-3",
      serviceName: "Cardiology Review & ECG",
      date: dayPlus1,
      time: "14:00",
      duration: 60,
      price: 150,
      status: "confirmed",
      priority: "VIP",
      room: "Cardiac Center 4A",
      notes: "Executive health screen. Holter monitor download review.",
      createdAt: new Date(Date.now() - 3600000 * 30).toISOString()
    },

    // Day + 2 appointments
    {
      id: "apt-109",
      referenceCode: "MED-9029",
      clientName: "Benjamin Foster",
      email: "ben.foster@example.com",
      phone: "+1 (555) 123-7890",
      specialistId: "spec-4",
      specialistName: "Dr. Alexander Kim",
      serviceId: "srv-4",
      serviceName: "Dermatology Skin Screening",
      date: dayPlus2,
      time: "10:00",
      duration: 30,
      price: 110,
      status: "confirmed",
      priority: "Routine",
      room: "Derma Lab 3C",
      notes: "Skin allergy patch test evaluation.",
      createdAt: new Date(Date.now() - 3600000 * 14).toISOString()
    },
    {
      id: "apt-110",
      referenceCode: "MED-9030",
      clientName: "Grace Holloway",
      email: "grace.h@example.com",
      phone: "+1 (555) 234-9012",
      specialistId: "spec-5",
      specialistName: "Dr. Maya Lindqvist",
      serviceId: "srv-6",
      serviceName: "Orthopedic Physical Therapy",
      date: dayPlus2,
      time: "11:30",
      duration: 50,
      price: 120,
      status: "pending",
      priority: "Follow-up",
      room: "Rehab Gym 1F",
      notes: "Lower lumbar mobility and core stabilization assessment.",
      createdAt: new Date(Date.now() - 3600000 * 6).toISOString()
    },

    // Day + 3 appointments
    {
      id: "apt-111",
      referenceCode: "MED-9031",
      clientName: "Gabriel Reyes",
      email: "gabriel.r@example.com",
      phone: "+1 (555) 345-0123",
      specialistId: "spec-1",
      specialistName: "Dr. Evelyn Reed",
      serviceId: "srv-1",
      serviceName: "General Health Consultation",
      date: dayPlus3,
      time: "14:30",
      duration: 30,
      price: 65,
      status: "confirmed",
      priority: "Routine",
      room: "Suite 101 - Building A",
      notes: "Pre-travel vaccination consultation and malaria prophylaxis prescriptions.",
      createdAt: new Date(Date.now() - 3600000 * 22).toISOString()
    },
    {
      id: "apt-112",
      referenceCode: "MED-9032",
      clientName: "Isabella Rossi",
      email: "isabella.rossi@example.com",
      phone: "+1 (555) 456-1234",
      specialistId: "spec-2",
      specialistName: "Dr. Marcus Vance",
      serviceId: "srv-2",
      serviceName: "Dental Cleaning & Examination",
      date: dayPlus4,
      time: "15:30",
      duration: 45,
      price: 95,
      status: "confirmed",
      priority: "Routine",
      room: "Dental Clinic 2B",
      notes: "Enamel whitening follow-up inspection.",
      createdAt: new Date(Date.now() - 3600000 * 40).toISOString()
    },

    // Past appointments
    {
      id: "apt-113",
      referenceCode: "MED-9018",
      clientName: "Victor Castillo",
      email: "victor.c@example.com",
      phone: "+1 (555) 567-2345",
      specialistId: "spec-3",
      specialistName: "Dr. Sophia Patel",
      serviceId: "srv-3",
      serviceName: "Cardiology Review & ECG",
      date: dayMinus1,
      time: "09:30",
      duration: 60,
      price: 150,
      status: "completed",
      priority: "Routine",
      room: "Cardiac Center 4A",
      notes: "Stress echo test successfully performed. Normal exercise tolerance.",
      createdAt: new Date(Date.now() - 3600000 * 72).toISOString()
    },
    {
      id: "apt-114",
      referenceCode: "MED-9019",
      clientName: "Olivia Hughes",
      email: "olivia.h@example.com",
      phone: "+1 (555) 678-3456",
      specialistId: "spec-4",
      specialistName: "Dr. Alexander Kim",
      serviceId: "srv-4",
      serviceName: "Dermatology Skin Screening",
      date: dayMinus1,
      time: "11:00",
      duration: 30,
      price: 110,
      status: "cancelled",
      priority: "Routine",
      room: "Derma Lab 3C",
      notes: "Patient cancelled due to acute work conflict. Will re-schedule next week.",
      createdAt: new Date(Date.now() - 3600000 * 80).toISOString()
    },
    {
      id: "apt-115",
      referenceCode: "MED-9015",
      clientName: "Lucas Bennett",
      email: "lucas.b@example.com",
      phone: "+1 (555) 789-4567",
      specialistId: "spec-5",
      specialistName: "Dr. Maya Lindqvist",
      serviceId: "srv-6",
      serviceName: "Orthopedic Physical Therapy",
      date: dayMinus2,
      time: "14:00",
      duration: 50,
      price: 120,
      status: "completed",
      priority: "Routine",
      room: "Rehab Gym 1F",
      notes: "Shoulder impingement ultrasound therapy and resistance band protocol provided.",
      createdAt: new Date(Date.now() - 3600000 * 96).toISOString()
    },
    {
      id: "apt-116",
      referenceCode: "MED-9012",
      clientName: "Hannah Abbott",
      email: "hannah.a@example.com",
      phone: "+1 (555) 890-5678",
      specialistId: "spec-1",
      specialistName: "Dr. Evelyn Reed",
      serviceId: "srv-5",
      serviceName: "Pediatric Wellness Check",
      date: dayMinus3,
      time: "10:00",
      duration: 40,
      price: 80,
      status: "no-show",
      priority: "Routine",
      room: "Suite 101 - Building A",
      notes: "Patient missed appointment without prior notice. Follow-up SMS reminder sent.",
      createdAt: new Date(Date.now() - 3600000 * 120).toISOString()
    }
  ];
};
